﻿import {hasFlag, translation} from "@2d-front-monorepo/core";
import {IMvvmContextState, MvvmTextInput} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useMemo} from "react";
import AttachmentType from "../enums/AttachmentType";
import RequiredDriverProperties from "../installations/RequiredDriverProperties";
import ICreateComponentAttachments from "../interfaces/ICreateComponentAttachments";
import {CreateDriverArguments} from "../types/arguments/CreateDriverArguments";
import {ComponentWithChildrenParts} from "./ComponentParts";
import CreateAttachmentsComponent from "./CreateAttachmentsComponent";

export interface CreateDriverComponentProps extends ComponentWithChildrenParts {
	context: IMvvmContextState<CreateDriverModel>;

	requiredProperties: RequiredDriverProperties;
	readOnlyProperties?: RequiredDriverProperties;
	hiddenProperties?: RequiredDriverProperties;
	
	requiredAttachments?: AttachmentType[];
	optionalAttachments?: AttachmentType[];
}

export type CreateDriverModel = {
	arguments: CreateDriverArguments;
	customData: Record<string, any>;
} & ICreateComponentAttachments;

export default function CreateDriverComponent(props: CreateDriverComponentProps): JSX.Element {
	const {
		context,
		requiredProperties,
		readOnlyProperties,
		hiddenProperties,
		requiredAttachments,
		optionalAttachments,
		header,
		children,
		footer
	} = props;

	const roProperties = readOnlyProperties ? readOnlyProperties : RequiredDriverProperties.None;
	const hProperties = hiddenProperties ? hiddenProperties : RequiredDriverProperties.None;

	const fullNameValidation = useMemo(() => {
		return hasFlag(requiredProperties, RequiredDriverProperties.Fullname) ? {required: translation(PermitTranslations.validation__driver__full_name__required)} : undefined;
	}, [requiredProperties]);

	const licenseNumberValidation = useMemo(() => {
		return hasFlag(requiredProperties, RequiredDriverProperties.LicenseNumber) ? {required: translation(PermitTranslations.validation__driver__license_number__required)} : undefined;
	}, [requiredProperties]);

	return (<div className="layout vertical gap">
		{header}
		<div className="columns gap">
			<MvvmTextInput context={context}
			               property="arguments.fullName"
			               type="text"
			               column="col50"
			               autoFocus
			               hidden={hasFlag(hProperties, RequiredDriverProperties.Fullname)}
			               disabled={hasFlag(roProperties, RequiredDriverProperties.Fullname)}
			               validation={fullNameValidation}
			               label={translation(PermitTranslations.new_driver__full_name)}/>

			<MvvmTextInput context={context}
			               property="arguments.licenseNumber"
			               type="text"
			               column="col50"
			               hidden={hasFlag(hProperties, RequiredDriverProperties.LicenseNumber)}
			               disabled={hasFlag(roProperties, RequiredDriverProperties.LicenseNumber)}
			               validation={licenseNumberValidation}
			               label={translation(PermitTranslations.new_driver__license_number)}/>

		</div>
		{children}
		<CreateAttachmentsComponent context={context}
		                            label={translation(PermitTranslations.documentation__required)}
		                            types={requiredAttachments}
		                            required={true}/>

		<CreateAttachmentsComponent context={context}
		                            label={translation(PermitTranslations.documentation__additional)}
		                            types={optionalAttachments}
		                            required={false}/>
		{footer}
	</div>);
}
